<template>
  <div>
    <filter-slot
      :filter="showFilters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-monitoring-detail-report'].refresh()"
      :showPagination="false"
      :buttons-col-config="{ sm: 12, md: 12, lg: 12 }"
      buttons-wrapper-class="d-flex justify-content-end align-items-center"
    >
      <template #buttons>
        <b-button
          class="my-1"
          variant="info"
          v-b-tooltip.hover.top="$t('Download Excel')"
          @click="exportToExcel"
        >
          <feather-icon icon="FileTextIcon" /> Excel
        </b-button>
      </template>
      <template #table>
        <b-table
          ref="ref-table-monitoring-detail-report"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="showFields"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>
          <template #cell(code)="data">
            <div class="d-flex">
              <div class="pt-1">
                <feather-icon
                  v-if="data.item.personal_type == 'Driver'"
                  icon="TruckIcon"
                  size="22"
                  class="text-warning"
                />
                <feather-icon
                  v-else
                  icon="UserIcon"
                  size="22"
                  class="text-success"
                />
              </div>
              <div class="ml-1">
                <span> {{ data.item.personal_name | capitalize }} </span> <br />
                <span style="opacity: 0.5"> #{{ data.item.code }} </span>
              </div>
            </div>
          </template>
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="`light-${
                data.value == 'Active' ? 'success' : 'danger'
              }`"
            >
              <span>{{ $t(data.value) | capitalize }}</span>
            </b-badge>
          </template>
          <template #cell(is_viatic)="data">
            <b-badge
              pill
              :variant="`light-${data.value == 'Apply' ? 'success' : 'danger'}`"
            >
              <span>{{ $t(data.value) | capitalize }}</span>
            </b-badge>
          </template>
          <template #cell(ut_type)="data">
            <span v-if="data.value">
              {{ ut_types.find((x) => x.id == data.value).value }}
            </span>
            <span v-else> - </span>
          </template>
          <template #cell(entity_group_name)="data">
            <span> {{ data.value | capitalize }} </span>
          </template>
          <template #cell()="data">
            <span
              @click="insertPersonalAttendance(data.item, data.value.key)"
              class="cursor-pointer"
              v-b-tooltip.hover.left="
                data.value.comment != 'null' ? data.value.comment : ''
              "
            >
              <b-avatar
                rounded
                :variant="resolvColor(data.value.homework_status_id)"
                badge-top
                badge-variant="danger"
                badge-offset="-2px"
              >
                <template
                  #badge
                  v-if="data.value.comment && data.value.comment != 'null'"
                ></template>
                <span v-if="data.value.homework_status_id">
                  {{ data.value.abbreviation }}
                </span>
                <feather-icon v-else icon="AlertTriangleIcon" />
              </b-avatar>
            </span>
          </template>

          <!-- <template #head(dl)="scope">
            <b-button
              variant="link"
              class="p-0 d-flex align-items-center"
              @click="sortBy(scope.field.key)"
            >
              {{ scope.label }}
              <b-icon icon="arrow-down-up" class="ml-1 text-muted" />
            </b-button>
          </template> -->

          <template #cell(dl)="data">
            <b-badge
              @click="
                getAttendanceDetailsByStatus(
                  data.item.id,
                  6,
                  data.item.dl,
                  data.item
                )
              "
              pill
              :variant="`light-${countHomeworkStatusVariant(data.value)}`"
              class="text-capitalize"
              :class="{ 'cursor-pointer': data.value > 0 }"
            >
              <span> {{ data.value }}</span>
            </b-badge>
          </template>
          <template #cell(va)="data">
            <b-badge
              @click="
                getAttendanceDetailsByStatus(
                  data.item.id,
                  7,
                  data.item.va,
                  data.item
                )
              "
              pill
              :variant="`light-${countHomeworkStatusVariant(data.value)}`"
              class="text-capitalize"
              :class="{ 'cursor-pointer': data.value > 0 }"
            >
              <span> {{ data.value }}</span>
            </b-badge>
          </template>
          <template #cell(do)="data">
            <b-badge
              @click="
                getAttendanceDetailsByStatus(
                  data.item.id,
                  16,
                  data.item.do,
                  data.item
                )
              "
              pill
              :variant="`light-${countHomeworkStatusVariant(data.value)}`"
              class="text-capitalize"
              :class="{ 'cursor-pointer': data.value > 0 }"
            >
              <span> {{ data.value }}</span>
            </b-badge>
          </template>
          <template #cell(ps)="data">
            <b-badge
              @click="
                getAttendanceDetailsByStatus(
                  data.item.id,
                  5,
                  data.item.ps,
                  data.item
                )
              "
              pill
              :variant="`light-${countHomeworkStatusVariant(data.value)}`"
              class="text-capitalize"
              :class="{ 'cursor-pointer': data.value > 0 }"
            >
              <span> {{ data.value }}</span>
            </b-badge>
          </template>
          <template #cell(fa)="data">
            <b-badge
              @click="
                getAttendanceDetailsByStatus(
                  data.item.id,
                  3,
                  data.item.fa,
                  data.item
                )
              "
              pill
              :variant="`light-${countHomeworkStatusVariant(data.value)}`"
              class="text-capitalize"
              :class="{ 'cursor-pointer': data.value > 0 }"
            >
              <span> {{ data.value }}</span>
            </b-badge>
          </template>
        </b-table>
      </template>
    </filter-slot>

    <AttendanceDetailsByStatus
      v-if="attendanceDetailsByStatus"
      :dataModal="dataModal"
      @hideModal="hideAttendanceDetailsByStatus"
    />

    <PersonalAttendance
      v-if="personalAttendance"
      :dataModal="dataModal"
      @hideModal="hidePersonalAttendance"
    />
  </div>
</template>

<script>
import moment from "moment";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import AttendanceDetailsByStatus from "@/views/monitoring/views/attendance/components/modals/AttendanceDetailsByStatus.vue";
import PersonalAttendance from "@/views/monitoring/views/attendance/components/modals/PersonalAttendance.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import Filters from "@/views/monitoring/views/reports/data/filters.asistencia.conductores.js";
import Fields from "@/views/monitoring/views/reports/data/fields.data.js";

import ReportsService from "@/views/monitoring/views/reports/services/reports.service.js";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";
import ViaticService from "@/views/monitoring/views/viatic/services/viatic.service.js";

import { mapGetters } from "vuex";

export default {
  components: {
    FilterSlot,
    AttendanceDetailsByStatus,
    PersonalAttendance,
  },
  data() {
    return {
      ut_types: [
        { id: 1, value: "Camion Carreta" },
        { id: 2, value: "C - Camión" },
        { id: 3, value: "TS - Tracto Semiremolque" },
        { id: 4, value: "CR - Camión Remolque" },
      ],
      filters: [...Filters],
      // items: Usuarios,
      params: 1,
      fields: [...Fields],
      isBusy: false,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      attendanceDetailsByStatus: false,
      personalAttendance: false,
      dataModal: {},
      snapshotSortBy: null,
      snapshotOrderBy: null,
    };
  },
  computed: {
    showFields() {
      this.fields[0].variant = this.isDarkSkin ? "dark" : "light";
      return this.fields.filter((item) => item.visible);
      // const fieldsVisible = this.fields.filter((item) => this.$t(item.visible));
      // return fieldsVisible.map((element) => ({
      //   ...element,
      //   label: this.$t(element.label),
      // }));
    },
    showFilters() {
      return this.filters.filter((item) => item.visible);
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  mounted() {
    this.filters[0].model = moment().format("YYYY-MM-DD");
  },
  created() {
    this.getEntityGroups();
    this.fields[5].visible = false;
    // this.fields[6].visible = false;
    this.fields[7].visible = false;
    this.fields[8].visible = false;
    this.fields[9].visible = false;
    this.fields[10].visible = false;
    this.fields[11].visible = false;
  },
  methods: {
    // sortBy(field) {
    //   this.myProvider({
    //     currentPage: this.paginate.currentPage,
    //     perPage: this.paginate.perPage,
    //     sortBy: field,
    //     sortDesc: false,
    //   });
    // },
    async myProvider(ctx) {
      try {
        this.addPreloader();

        let sortBy = null;

        switch (ctx.sortBy) {
          case "code":
            sortBy = 4; // nombre del empleado
            break;
          case "is_viatic":
            sortBy = 7;
            break;
            // case "dl": no sirve porque el cell no ordena posible solucion mover a items en vez de usar provider
            //   sortBy = 14; // dl
            break;
          default:
            sortBy = 4;
            break;
        }

        this.snapshotSortBy = sortBy;
        this.snapshotOrderBy = ctx.sortDesc ? "DESC" : "ASC";

        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search_txt: this.filterPrincipal.model,
          date: this.filters[0].model, // Date
          personal_type: null, // No tienes filtro visual para esto
          is_viatic: this.filters[1].model, // Viatic
          status: this.filters[2].model != null ? this.filters[2].model : 1, // Status Personal
          entity_group_id: this.filters[3].model, // Entity Group
          sort_field: this.snapshotSortBy,
          sort_order: this.snapshotOrderBy,
        };

        const { data } = await ReportsService.getMonthlyAttendanceReport(
          params
        );

        let resultados = data.data.data;

        // // si es 14 ordenar por dl
        // if (sortBy == 14) {
        //   console.log("ordenando por dl");
        //   if (ctx.sortDesc) {
        //     resultados = resultados.sort((a, b) => a.dl - b.dl);

        //   } else {
        //     resultados = resultados.sort((a, b) => b.dl - a.dl);

        //   }
        // }

        // console.table(resultados);

        this.paginate.from = data.data.from;
        this.paginate.to = data.data.to;
        this.paginate.of = data.data.total;
        this.paginate.perPage = data.data.per_page;
        this.paginate.currentPage = data.data.current_page;
        this.fields = [...Fields];

        data.keys.map((item) =>
          this.fields.push({
            key: item,
            label: item,
            thClass: "text-center",
            tdClass: "text-center",
            visible: true,
          })
        );
        return resultados;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async insertPersonalAttendance(item, day) {
      if (this.isCeo || this.isChief) {
        try {
          this.addPreloader();
          const params = {
            date: item[day].date,
            attendance_id: item.id,
          };
          const { data } = await ViaticService.validateApprovedAttendance(
            params
          );
          // if (data.isApproved == false) {
          this.dataModal = {
            id: item.id,
            id_detail: item[day].id,
            code: item.code,
            personal_name: item.personal_name,
            date: item[day].date,
            homework_status_id: item[day].homework_status_id || null,
            observation: item[day].observation || null,
            comment: item[day].comment || null,
            origin: "viatic",
            approved: data.isApproved,
            attendance_status_viatic_id: data.att?.attendance_status_viatic_id,
            payroll_id: data.att?.payroll_id,
          };
          this.personalAttendance = true;
          // return;
          // }
          // this.$toast({
          //   component: ToastificationContent,
          //   position: "top-center",
          //   props: {
          //     title: "Warning",
          //     icon: "CoffeeIcon",
          //     variant: "warning",
          //     text: "Attendance already approved.",
          //   },
          // });
          // return;
        } catch (error) {
          console.log(error);
        } finally {
          this.removePreloader();
        }
      }
    },
    async getEntityGroups() {
      try {
        this.addPreloader();
        const { data } = await EmployeeService.getEntitiesGroup();
        this.filters[3].options = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    homeworkStatusVariant(homework_status_id) {
      if (homework_status_id == null) return "default";
      if (homework_status_id === 3) return "danger";
      if (homework_status_id === 4) return "warning";
      if (homework_status_id === 1 || homework_status_id === 2)
        return "success";
      if (homework_status_id === "inactive") return "secondary";
      return "primary";
    },
    resolvColor(homework_status_id) {
      if (homework_status_id == null) return "light-warning";
      switch (homework_status_id) {
        case 1:
          return "light-primary";
          break;
        case 2:
          return "light-success";
          break;
        case 3:
          return "light-danger";
          break;
        default:
          return "light-info";
          break;
      }
    },
    countHomeworkStatusVariant(count) {
      if (count === 0) return "success";
      if (count > 0 && count <= 3) return "warning";
      return "danger";
    },
    todayRecord(attendance_id, today, item) {
      this.dataModal = {
        attendance_id,
        personal_name: item.personal_name,
        code: item.code,
        today,
      };
      this.attendanceDetailsByStatus = true;
    },
    hideAttendanceDetailsByStatus() {
      this.attendanceDetailsByStatus = false;
    },
    setAttendance(item) {
      this.dataModal = item;
      this.dataModal.origin = "attendance";
      this.personalAttendance = true;
    },
    hidePersonalAttendance(action = false) {
      if (action == true) {
        this.$refs["ref-table-monitoring-detail-report"].refresh();
      }
      this.personalAttendance = false;
    },
    getAttendanceDetailsByStatus(
      attendance_id,
      homework_status_id,
      count,
      item
    ) {
      this.dataModal = {
        attendance_id,
        homework_status_id,
        personal_name: item.personal_name,
        code: item.code,
      };
      this.attendanceDetailsByStatus = true;
    },
    async exportToExcel() {
      try {
        this.addPreloader();

        const params = {
          search_txt: this.filterPrincipal.model,
          date: this.filters[0].model, // Date
          personal_type: null, // No tienes filtro visual para esto
          is_viatic: this.filters[1].model, // Viatic
          status: this.filters[2].model != null ? this.filters[2].model : 1, // Status Personal
          entity_group_id: this.filters[3].model, // Entity Group
          sort_field: this.snapshotSortBy,
          sort_order: this.snapshotOrderBy,
          type: "export",
        };

        // const { data } = await ReportsService.exportToExcel(params);
        // this.forceFileDownload(data, "report.xlsx");

        const response = await ReportsService.exportToExcel(params);

        // Extraer nombre de archivo desde el header Content-Disposition
        const disposition = response.headers["content-disposition"];
        let filename = "vacaciones.xlsx";
        if (disposition && disposition.includes("filename=")) {
          filename = disposition
            .split("filename=")[1]
            .replace(/['"]/g, "") // eliminar comillas si hay
            .trim();
        }

        this.forceFileDownload(response.data, filename);
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style>
</style>